import InputWrapper from "@egovernments/digit-ui-module-obps/src/pages/citizen/AVPForms/layout/inputWrapper";
import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";

const ReusableFloorDetail = ({ defaultValues, control, formData, isEmployee, isUploadDocsOrShortFall = null }) => {
  const { t } = useTranslation();

  return (
    <div className="formContainer">
      <div className="formHeaderContainer">
        <h2 className="formHeading">{t("Total no of floor")}</h2>
      </div>
      <Container fluid className="formInputContainer common-app-form reuse">
        <Row>
          <Col>
            <InputWrapper
              label={t("Basement")}
              control={control}
              placeholder={t("Enter Number of Basements")}
              name="basementArea"
              mandatory
              maxLength={2}
              // disabled={isEmployee ? false : formData?.basementArea}
              disabled={
                isEmployee ? false : isUploadDocsOrShortFall != null ? isUploadDocsOrShortFall && !!formData?.basementArea : !!formData?.basementArea
              }
              //   defaultValue={formData?.descriptionOfLand?.landArea}
              type="number"
              validation={{
                required: {
                  value: true,
                  message: "This field is required",
                },
              }}
            />
          </Col>

          <Col>
            <InputWrapper
              label={t("Stilt")}
              control={control}
              placeholder={t("Enter Number of Stilts")}
              name="stiltArea"
              mandatory
              maxLength={2}
              //   defaultValue={formData?.descriptionOfLand?.landArea}
              // disabled={isEmployee ? false : formData?.stiltArea}
              disabled={
                isEmployee ? false : isUploadDocsOrShortFall != null ? isUploadDocsOrShortFall && !!formData?.stiltArea : !!formData?.stiltArea
              }
              type="number"
              validation={{
                required: {
                  value: true,
                  message: "This field is required",
                },
              }}
            />
          </Col>
        </Row>
        <Row>
          <Col>
            <InputWrapper
              label={t("Floors")}
              control={control}
              placeholder={t("Enter Number of Floors")}
              name="floors"
              mandatory
              maxLength={2}
              // disabled={isEmployee ? false : formData?.floors}
              disabled={isEmployee ? false : isUploadDocsOrShortFall != null ? isUploadDocsOrShortFall && !!formData?.floors : !!formData?.floors}
              //   defaultValue={formData?.descriptionOfLand?.landArea}
              type="number"
              validation={{
                required: {
                  value: true,
                  message: "This field is required",
                },
              }}
            />
          </Col>
          <Col>
            <InputWrapper
              label={t("Building Height (m)")}
              control={control}
              placeholder={t("Enter Building Height")}
              name="buildingHeight"
              mandatory
              maxLength={4}
              disabled={
                isEmployee
                  ? false
                  : isUploadDocsOrShortFall != null
                  ? isUploadDocsOrShortFall && !!formData?.buildingHeight
                  : !!formData?.buildingHeight
              }
              defaultValue={formData?.buildingHeight}
              type="specialChar"
              allowedChars="."
              onlyNumeric={true}
              validation={{
                required: {
                  value: true,
                  message: "This field is required",
                },
              }}
            />
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default ReusableFloorDetail;
